import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetStore } from '@/Infrastructure/applicationSlice';

interface EdiLoadTenderState {
	loadingSet: number[];
}

const initialState: EdiLoadTenderState = {
	loadingSet: []
};

const ediLoadTenderSlice = createSlice({
	name: 'ediLoadTenderState',
	initialState,
	reducers: {
		setEdiLoading(state, action: PayloadAction<number | number[]>) {
			const payload = ([] as number[]).concat(action.payload);
			return {
				...state,
				loadingSet: [...state.loadingSet, ...payload]
			};
		},
		clearEdiLoading(state, action: PayloadAction<number | number[]>) {
			const payload = ([] as number[]).concat(action.payload);
			const newLoadingSet = [...state.loadingSet.filter((x) => !payload.includes(x))];
			return {
				...state,
				loadingSet: newLoadingSet
			};
		}
	},
	extraReducers: (builder) => {
		builder.addCase(resetStore, () => {
			return initialState;
		});
	}
});

export const { setEdiLoading, clearEdiLoading } = ediLoadTenderSlice.actions;

export default ediLoadTenderSlice;
